/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {KTIcon} from '../../../helpers'
import {Dropdown1} from '../../content/dropdown/Dropdown1'
import {useNavigate} from 'react-router-dom'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faClose, faMagnifyingGlass} from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'
import ReactPaginate from 'react-paginate'

type Props = {
  allConfigs: any
}

const RegionConfigTable: React.FC<Props> = ({allConfigs}) => {
  let navigate = useNavigate()
  const [allConfigurations, setAllConfigurations] = useState(allConfigs)
  const [showSearchBox, setShowSearchBox] = useState(true)
  const [searchValue, setSearchValue] = useState<any>(null)
  const [searchResults, setSearchResults] = useState<any>(null)
  const [currentPage, setCurrentPage] = useState(0)
  const itemsPerPage = 10

  const handleUpdateRegion = (config: any) => {
    navigate('/updateregion/' + config.country_code)
  }

  useEffect(() => {
    setAllConfigurations(allConfigs)
  }, [allConfigs])

  const handleSearchData = (value: any) => {
    setCurrentPage(0)
    if (!searchValue) {
      setAllConfigurations(allConfigs)
    } else {
      const filteredArray = allConfigs.filter((item: any) =>
        item.country_name.toLowerCase().includes(searchValue.toLowerCase())
      )

      setAllConfigurations(filteredArray)
    }
  }

  useEffect(() => {
    handleSearchData(searchValue)
  }, [searchValue])

  const handleSearch = (value: any) => {
    setSearchValue(value)
  }

  const handlePageClick = (data: any) => {
    setCurrentPage(data.selected)
  }

  const offset = currentPage * itemsPerPage
  const paginatedData = allConfigurations?.slice(offset, offset + itemsPerPage)

  return (
    <div className={`card ${allConfigurations}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <div className='d-flex align-items-center' style={{position: 'relative', width: '100%'}}>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Region Cofigurations</span>
            <span className='text-muted mt-1 fw-semibold fs-7'>All Region Configurations</span>
          </h3>
          <div style={{display: 'flex', alignItems: 'center', position: 'absolute', right: '3%'}}>
            <input
              type='text'
              className='search-input form-control form-control-solid ps-13'
              name='search'
              placeholder='Search...'
              data-kt-search-element='input'
              value={searchValue}
              onChange={(e) => {
                handleSearch(e.target.value)
              }}
            />
            <KTIcon
              iconName='magnifier'
              className='fs-2 text-lg-3 text-gray-800 position-absolute top-50 translate-middle-y ms-5'
            />
          </div>
        </div>
        <div className='card-toolbar'></div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3' style={{height: '55vh', overflow: 'scroll'}}>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table align-middle gs-0 gy-3'>
            {/* begin::Table head */}
            <thead>
              <tr>
                {/* <th className='p-0 w-50px'></th> */}
                <th className='text-dark fw-bold p-0 text-center' style={{width: '10%'}}>
                  Region Id
                </th>
                <th className='text-dark fw-bold p-0 text-center' style={{width: '30%'}}>
                  Region Name
                </th>
                <th className='text-dark fw-bold p-0 ' style={{width: '50%'}}>
                  Configurations
                </th>
                <th className='text-dark fw-bold p-0 text-center' style={{width: '10%'}}>
                  Actions
                </th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
              {paginatedData
                ? paginatedData.map((configuration: any, index: any) => {
                    return (
                      <tr key={index}>
                        <td className='text-center'>
                          <p> {configuration.country_code}</p>
                        </td>

                        <td className='text-center'>
                          <p> {configuration.country_name}</p>
                        </td>
                        {configuration.configuration == null ? (
                          <>
                            <td>
                              <p>
                                <span style={{fontWeight: '600'}}>Configurations Not Found</span>
                              </p>
                            </td>
                          </>
                        ) : (
                          <td>
                            <p>
                              <span style={{fontWeight: '600'}}>Stations :</span>
                              <span
                                style={
                                  configuration.configuration.showStations
                                    ? {color: 'green'}
                                    : {color: 'red'}
                                }
                              >
                                {configuration.configuration.showStations == true ? 'On' : 'Off'}
                              </span>
                            </p>
                            <p>
                              <span style={{fontWeight: '600'}}>Popular Podcast :</span>
                              <span
                                style={
                                  configuration.configuration.showPopPod
                                    ? {color: 'green'}
                                    : {color: 'red'}
                                }
                              >
                                {configuration.configuration.showPopPod == true ? 'On' : 'Off'}
                              </span>
                            </p>
                            <p>
                              <span style={{fontWeight: '600'}}>Trending Podcast :</span>
                              <span
                                style={
                                  configuration.configuration.showTrendPod
                                    ? {color: 'green'}
                                    : {color: 'red'}
                                }
                              >
                                {configuration.configuration.showTrendPod == true ? 'On' : 'Off'}
                              </span>
                            </p>
                            <p>
                              <span style={{fontWeight: '600'}}> Number of slides :</span>
                              <span>
                                {configuration.configuration.slides
                                  ? configuration.configuration.slides.length
                                  : '0'}
                              </span>
                            </p>
                          </td>
                        )}

                        <td className='d-flex justify-content-center'>
                          <button
                            type='button'
                            className='btn btn-outline btn-outline-warning rounded-1 btn-sm'
                            data-kt-menu-trigger='click'
                            data-kt-menu-placement='bottom-end'
                            data-kt-menu-flip='top-end'
                            onClick={() => {
                              handleUpdateRegion(configuration)
                            }}
                          >
                            <span className=''>Update</span>
                          </button>
                        </td>
                      </tr>
                    )
                  })
                : ''}
            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>

      <div style={{marginTop: '20px', marginBottom: '20px'}}>
        <ReactPaginate
          previousLabel={'previous'}
          nextLabel={'next'}
          breakLabel={'...'}
          breakClassName={'break-me'}
          pageCount={Math.ceil(allConfigurations?.length / itemsPerPage)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={(selectedPage) => handlePageClick(selectedPage)}
          containerClassName={'pagination'}
          // subContainerClassName={'pages pagination'}
          activeClassName={'active'}
        />
      </div>
      {/* begin::Body */}
    </div>
  )
}

export {RegionConfigTable}
